module.exports = __webpack_public_path__ + "static/img/IMG_20240209_134418.9661a0e0.jpg";